import "./App.css";
import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Home from "./components/home";
import DetailPage from "./components/detail";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/userDetails/:id" element={<DetailPage />} />
      </Routes>
    </Router>
  );
}

export default App;
